/**
 * The four successor buckets share the same "is anything selected" test across
 * the start event, step tasks, and decision rules. orgFunctions / systems carry
 * EntityOrSuggestionRef[] — a pending/rejected suggestion is already an entry in
 * those arrays, so a length check captures resolved entities and suggestions alike.
 */
export type SuccessorBuckets = {
  persons?: unknown[];
  orgFunctions?: unknown[];
  systems?: unknown[];
  externalContacts?: unknown[];
};

export function hasAnySuccessor(successors: SuccessorBuckets | null | undefined): boolean {
  if (!successors) return false;
  return Boolean(
    successors.persons?.length ||
    successors.orgFunctions?.length ||
    successors.systems?.length ||
    successors.externalContacts?.length
  );
}
